export interface Category {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export interface Section {
  heading: string;
  body: string;
}

export interface Collection {
  id: string;
  title: string;
  summary: string;
  categoryId: string;
  categoryName: string;
  cover: string;
  heat: number;
  date: string;
  readTime: string;
  tags: string[];
  sections: Section[];
  points: string[];
}

export interface WeeklyItem {
  id: string;
  day: string;
  date: string;
  title: string;
  summary: string;
  tag: string;
}

export interface Quote {
  id: string;
  name: string;
  role: string;
  text: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const siteInfo = {
  name: "吃瓜合集导航",
  slogan: "一站式吃完全部瓜",
  intro:
    "吃瓜合集导航是一个面向泛娱乐兴趣用户的话题聚合站，把散落在各个平台的热门娱乐话题、一周盘点与必看清单，按热度重新整理成一份份可以直接顺着看完的合集。",
  email: "hello@chigua-nav.com",
  sloganLine: "按热度整理 · 按合集浏览 · 一周不断更",
};

export const categories: Category[] = [
  { id: "variety", name: "综艺爆料", desc: "节目录制花絮、番位讨论与现场反响", icon: "ri-tv-2-line", count: 128 },
  { id: "setlife", name: "剧组路透", desc: "开机杀青、造型剧透与拍摄侧写", icon: "ri-clapperboard-line", count: 96 },
  { id: "stage", name: "音乐现场", desc: "舞台直拍、歌单与巡演话题整理", icon: "ri-mic-line", count: 74 },
  { id: "redcarpet", name: "红毯时尚", desc: "造型盘点、品牌合作与同框名场面", icon: "ri-vip-diamond-line", count: 63 },
  { id: "fandom", name: "粉丝互动", desc: "应援现场、二创热潮与社区话题", icon: "ri-heart-3-line", count: 88 },
  { id: "brand", name: "品牌代言", desc: "商务动向、联名发布与物料合集", icon: "ri-shopping-bag-3-line", count: 41 },
];

export const hotEvents: Collection[] = [
  {
    id: "variety-seat-order",
    title: "综艺番位之争再上热搜：镜头分配到底看什么",
    summary:
      "一档热播群像综艺播出后，关于嘉宾镜头时长与座位顺序的讨论快速升温。我们整理了播出片段、嘉宾出场节奏与观众反馈，帮你三分钟看懂这次讨论的来龙去脉。",
    categoryId: "variety",
    categoryName: "综艺爆料",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20variety%20show%20studio%20stage%20with%20soft%20amber%20lights%2C%20colorful%20seats%20and%20empty%20microphone%20stands%2C%20editorial%20entertainment%20photography%2C%20clean%20minimal%20composition%2C%20coral%20and%20cream%20tone&width=900&height=600&seq=chigua-variety-01&orientation=landscape",
    heat: 9820,
    date: "09-08",
    readTime: "6 分钟",
    tags: ["群像综艺", "镜头分配", "观众讨论"],
    sections: [
      {
        heading: "话题是怎么起来的",
        body: "节目正片上线当晚，社交平台上陆续出现对比片段，讨论从单个游戏环节延伸到整期的出场节奏。由于群像类节目嘉宾众多，镜头如何分配本身就是一个长期存在的观察点。",
      },
      {
        heading: "被反复提及的几个片段",
        body: "观众集中讨论的是开场自我介绍、组队游戏与最后的结果公布三段。前两段被用来判断互动量，最后一段则因为情绪表达比较集中，成为二次剪辑的主要素材来源。",
      },
      {
        heading: "为什么这类讨论总能持续",
        body: "群像综艺的看点本就分散在多人之间，观众会自然形成不同的关注重心。当关注重心出现交叉，讨论就容易从节目内容转向上镜机会的公平性，这也是同类话题反复出现的根本原因。",
      },
      {
        heading: "理性看瓜的小建议",
        body: "正片之外的物料往往覆盖更完整的录制过程，单看一段剪辑容易得出偏差结论。想了解全貌，建议至少对照正片、加更与幕后花絮三类内容，再做判断。",
      },
    ],
    points: [
      "对比片段大多来自正片，未必代表完整录制过程",
      "镜头时长受环节设置影响，不等于嘉宾表现好坏",
      "加更与花絮常包含被正片剪掉的关键互动",
    ],
  },
  {
    id: "drama-wrap-photos",
    title: "新剧杀青路透合集：造型变化与拍摄地侧写",
    summary:
      "一部现代剧日前完成杀青，从开机到收工跨度约四个月。我们按时序整理了公开路透中的造型变化与拍摄地线索，还原这部剧的拍摄轨迹。",
    categoryId: "setlife",
    categoryName: "剧组路透",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20at%20golden%20hour%20with%20vintage%20director%20chair%2C%20clapperboard%20and%20warm%20dusty%20light%2C%20editorial%20photography%2C%20muted%20coral%20and%20cream%20palette%2C%20clean%20minimal%20background&width=900&height=600&seq=chigua-set-02&orientation=landscape",
    heat: 8640,
    date: "09-07",
    readTime: "5 分钟",
    tags: ["杀青", "路透", "造型"],
    sections: [
      {
        heading: "拍摄时间线",
        body: "剧组在初春开机，经历了外景与棚拍两个主要阶段。公开路透显示，前期以外景为主，中后期集中回到棚内完成高密度拍摄。",
      },
      {
        heading: "造型变化透露了什么",
        body: "从路透看，角色造型经历了从通勤到职业装的明显转变，整体色调也随剧情推进逐渐收敛。这种由松到紧的造型节奏，在都市题材里通常用来标记人物状态的变化。",
      },
      {
        heading: "拍摄地线索整理",
        body: "结合公开画面中的建筑风格与街道特征，拍摄地大致覆盖了商务区、老城区与近郊三类场景，与前期的剧情设定基本吻合。",
      },
      {
        heading: "杀青之后还有什么",
        body: "杀青只代表拍摄结束，后续还有剪辑、配乐与调色。按同类项目节奏，从杀青到与观众见面通常还需要一段时间，期间的官方物料会陆续放出。",
      },
    ],
    points: [
      "造型色调变化常与人物状态曲线对应",
      "路透画面不代表最终成片效果",
      "杀青到定档之间通常还有较长制作周期",
    ],
  },
  {
    id: "concert-tour-list",
    title: "巡演歌单流出？一场演出引发的编曲讨论",
    summary:
      "某歌手巡演现场的一段改编编曲在平台上快速传播，围绕编曲方向与歌单顺序的讨论随之展开。我们把现场反馈和公开信息拼在一起，看看这次改编为什么会被反复讨论。",
    categoryId: "stage",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Live%20music%20concert%20stage%20with%20warm%20amber%20spotlights%2C%20silhouette%20of%20guitar%20and%20microphone%2C%20editorial%20concert%20photography%2C%20coral%20and%20gold%20tones%2C%20clean%20minimal%20composition&width=900&height=600&seq=chigua-stage-03&orientation=landscape",
    heat: 7910,
    date: "09-06",
    readTime: "4 分钟",
    tags: ["巡演", "编曲", "现场"],
    sections: [
      {
        heading: "被讨论的那一段",
        body: "引发讨论的是安可环节的一首改编曲目。相比录音室版本，现场版降低了速度并加重了低频，整体氛围更偏向叙事感。",
      },
      {
        heading: "改编思路的可能来源",
        body: "巡演的编曲通常会根据场馆声场与乐队配置做调整。慢速版本在大型场馆里更容易形成合唱，也方便加入即兴段落。",
      },
      {
        heading: "歌单顺序的逻辑",
        body: "从公开的现场记录看，整场歌单呈现出由快到慢、再由慢回快的曲线，安可部分承担收束情绪的作用，这与常见的巡演结构一致。",
      },
    ],
    points: [
      "现场改编通常会考虑场馆声场条件",
      "慢速版本更利于全场合唱与情绪积累",
      "巡演歌单结构往往呈现明显情绪曲线",
    ],
  },
  {
    id: "redcarpet-looks",
    title: "红毯造型盘点：这季最出圈的三种配色思路",
    summary:
      "一场年度盛典之后，红毯造型成为讨论重点。我们按配色把当晚的造型分成三类，梳理各自的视觉逻辑与呈现效果。",
    categoryId: "redcarpet",
    categoryName: "红毯时尚",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20backdrop%20with%20warm%20amber%20lighting%2C%20empty%20runway%20and%20soft%20bokeh%2C%20editorial%20fashion%20photography%2C%20coral%20and%20cream%20palette%2C%20minimal%20clean%20composition&width=900&height=600&seq=chigua-redcarpet-04&orientation=landscape",
    heat: 6430,
    date: "09-05",
    readTime: "5 分钟",
    tags: ["红毯", "造型", "配色"],
    sections: [
      {
        heading: "低饱和同色系",
        body: "这一类的思路是用整体统一的低饱和色调取胜，剪裁和材质成为主要看点，适合在密集的闪光灯下保持画面干净。",
      },
      {
        heading: "高对比撞色",
        body: "撞色造型通常靠一到两个强对比色块制造记忆点，风险与收益都更高，一旦比例失准就容易显得杂乱。",
      },
      {
        heading: "金属与光泽质感",
        body: "带有金属光泽的面料在夜间红毯上非常占优势，能自然捕捉灯光，形成类似高光的视觉效果。",
      },
    ],
    points: [
      "同色系靠剪裁与材质拉开层次",
      "撞色造型成败取决于色块比例",
      "金属光泽面料在夜间灯光下更出彩",
    ],
  },
  {
    id: "fan-support-scene",
    title: "应援现场图鉴：一场线下活动的组织全流程",
    summary:
      "一次线下活动的应援之所以被反复讨论，是因为它罕见地展示了完整组织过程。我们从物料、排班到散场整理了这套流程。",
    categoryId: "fandom",
    categoryName: "粉丝互动",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20fan%20event%20with%20warm%20string%20lights%2C%20banners%20and%20handheld%20glow%20sticks%20in%20soft%20evening%20light%2C%20editorial%20photography%2C%20coral%20gold%20and%20green%20accents%2C%20clean%20minimal%20background&width=900&height=600&seq=chigua-fandom-05&orientation=landscape",
    heat: 5580,
    date: "09-04",
    readTime: "6 分钟",
    tags: ["应援", "组织", "物料"],
    sections: [
      {
        heading: "物料准备阶段",
        body: "应援物料通常提前数周开始打样，包括横幅、手牌与统一的发光道具，尺寸与配色都需要跟着场馆规则调整。",
      },
      {
        heading: "现场排班",
        body: "活动现场会按区域划分负责人，负责物料发放、秩序维护与拍照记录，排班表是保证流程不乱的核心。",
      },
      {
        heading: "散场与收尾",
        body: "散场阶段的重点是恢复场地与清点物料，这部分往往决定了一场应援能否被场馆长期接受。",
      },
    ],
    points: [
      "物料尺寸需提前确认场馆规则",
      "分区负责制是现场秩序的关键",
      "散场收尾影响后续活动能否持续",
    ],
  },
  {
    id: "brand-collab-drop",
    title: "联名物料刷屏：一次发布如何变成社区话题",
    summary:
      "某品牌与新系列的联名物料上线后迅速扩散。我们拆解了这次发布的内容节奏与传播路径，看看它为什么能出圈。",
    categoryId: "brand",
    categoryName: "品牌代言",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20product%20launch%20scene%20with%20packaging%20boxes%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20commercial%20photography%2C%20coral%20and%20green%20accents%2C%20clean%20composition&width=900&height=600&seq=chigua-brand-06&orientation=landscape",
    heat: 4720,
    date: "09-03",
    readTime: "4 分钟",
    tags: ["联名", "发布", "传播"],
    sections: [
      {
        heading: "发布节奏",
        body: "这次发布采取了预告、悬念、正式上线三段式节奏，每一段都留出了社区自行解读的空间，讨论因此没有在一天内消耗完。",
      },
      {
        heading: "物料设计的巧思",
        body: "主视觉把产品放在暖色背景中，配色克制，方便二次创作时保留识别度，这也是它能被大量转发的原因之一。",
      },
      {
        heading: "社区如何接力",
        body: "上线后，社区围绕细节展开了二次创作，从壁纸到表情包，形成了官方物料之外的传播延展。",
      },
    ],
    points: [
      "三段式节奏延长了话题生命周期",
      "克制的配色更利于二次创作扩散",
      "社区二创是出圈的重要一环",
    ],
  },
  {
    id: "variety-cast-reunion",
    title: "老综艺回归：一次重聚为什么让讨论持续一周",
    summary:
      "某档经典群像综艺宣布回归，原班人马重聚的消息让相关话题在整个星期保持热度。我们梳理了这次回归的关键信息。",
    categoryId: "variety",
    categoryName: "综艺爆料",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20reunion%20table%20scene%20with%20amber%20hanging%20lamps%2C%20empty%20chairs%20and%20cozy%20interior%2C%20editorial%20photography%2C%20coral%20and%20cream%20tones%2C%20minimal%20clean%20composition&width=900&height=600&seq=chigua-reunion-07&orientation=landscape",
    heat: 8360,
    date: "09-02",
    readTime: "5 分钟",
    tags: ["回归", "重聚", "情怀"],
    sections: [
      {
        heading: "官宣信息整理",
        body: "官方释放的信息主要包括回归时间、嘉宾构成与节目形式。相比新一季，这次的重点明确放在原有成员的再次同框上。",
      },
      {
        heading: "情怀为什么有效",
        body: "情怀类内容的传播动力来自共同记忆，观众在讨论节目时，其实也在讨论自己当年看节目的那段经历。",
      },
      {
        heading: "需要留意的地方",
        body: "重聚类节目容易陷入单纯消耗回忆的困境，能否在新的节目形式里长出新的看点，才是它能否持续被讨论的关键。",
      },
    ],
    points: [
      "官宣核心信息集中在嘉宾与形式",
      "共同记忆是情怀传播的驱动力",
      "新形式能否成立决定长期热度",
    ],
  },
  {
    id: "drama-poster-style",
    title: "海报设计成话题：三组物料的视觉逻辑拆解",
    summary:
      "一部待播剧的系列海报因为风格统一而受到关注。我们从构图、配色与信息层级三个角度，看这组物料的设计思路。",
    categoryId: "setlife",
    categoryName: "剧组路透",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20minimal%20graphic%20posters%20on%20warm%20cream%20desk%20with%20soft%20natural%20light%2C%20editorial%20design%20photography%2C%20coral%20gold%20green%20accents%2C%20clean%20minimal%20background&width=900&height=600&seq=chigua-poster-08&orientation=landscape",
    heat: 3980,
    date: "09-01",
    readTime: "4 分钟",
    tags: ["海报", "设计", "物料"],
    sections: [
      {
        heading: "统一的构图骨架",
        body: "三组海报都采用了相同的人物站位与留白比例，形成系列感，也让观众在刷到任意一张时都能立刻识别。",
      },
      {
        heading: "配色与情绪",
        body: "整体配色围绕暖色展开，只在关键人物身上使用饱和更高的色块作为视觉落点，主次关系因此非常清晰。",
      },
      {
        heading: "信息层级",
        body: "剧名、主演与播出信息被分层放置，字号差距明显，即使在小尺寸缩略图下也能保住可读性。",
      },
    ],
    points: [
      "统一构图是系列感的来源",
      "高饱和色块用于标记视觉重心",
      "字号层级决定缩略图可读性",
    ],
  },
  {
    id: "brand-ambassador-list",
    title: "商务动向梳理：本月官宣合作全收录",
    summary:
      "本月多个品牌陆续官宣合作，我们按行业整理了公开信息，并标注了各次合作的物料方向与发布节奏。",
    categoryId: "brand",
    categoryName: "品牌代言",
    cover:
      "https://readdy.ai/api/search-image?query=Creative%20brand%20collaboration%20mood%20board%20with%20warm%20amber%20and%20coral%20swatches%20on%20clean%20desk%2C%20editorial%20photography%2C%20soft%20natural%20light%2C%20minimal%20composition&width=900&height=600&seq=chigua-ambassador-09&orientation=landscape",
    heat: 3260,
    date: "08-31",
    readTime: "5 分钟",
    tags: ["商务", "官宣", "整理"],
    sections: [
      {
        heading: "时尚与美妆",
        body: "这一类的物料普遍强调视觉呈现，发布节奏紧凑，通常在官宣当天就会配合线下投放同步推进。",
      },
      {
        heading: "数码与家电",
        body: "这类合作更看重功能演示，物料以使用场景为主，宣传周期通常更长，会分阶段放出细节。",
      },
      {
        heading: "食品与快消",
        body: "快消品类节奏最快，强调即时可购买，发布与促销往往绑在一起，形成短期集中曝光。",
      },
    ],
    points: [
      "不同行业物料方向差异明显",
      "视觉型合作发布节奏更紧凑",
      "快消品类常与促销节点叠加",
    ],
  },
];

export const weeklyDigest: WeeklyItem[] = [
  {
    id: "w1",
    day: "周一",
    date: "09-08",
    title: "群像综艺镜头分配引讨论",
    summary: "对比片段密集出现，讨论重心从节目内容延伸到出场节奏。",
    tag: "综艺",
  },
  {
    id: "w2",
    day: "周二",
    date: "09-07",
    title: "新剧杀青路透合集上线",
    summary: "按时序整理的造型变化，成为本周被收藏最多的一份清单。",
    tag: "剧组",
  },
  {
    id: "w3",
    day: "周三",
    date: "09-06",
    title: "巡演改编编曲登上热榜",
    summary: "现场版速度与低频的调整，引发了关于编曲方向的讨论。",
    tag: "音乐",
  },
  {
    id: "w4",
    day: "周四",
    date: "09-05",
    title: "红毯造型盘点成焦点",
    summary: "按配色划分的三类造型思路，被大量转发引用。",
    tag: "时尚",
  },
  {
    id: "w5",
    day: "周六",
    date: "09-03",
    title: "联名物料刷屏社区",
    summary: "三段式发布节奏配合社区二创，让话题热度持续多日。",
    tag: "品牌",
  },
];

export const mustSee: Collection[] = [
  {
    id: "must-variety-guide",
    title: "群像综艺观看指南：先看哪一期最省时间",
    summary: "把分散的名场面按时间轴串起来，帮你用最短时间补完一档群像综艺的主要看点。",
    categoryId: "variety",
    categoryName: "综艺爆料",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20tv%20remote%20and%20popcorn%20on%20warm%20cream%20couch%20with%20soft%20amber%20light%2C%20editorial%20lifestyle%20photography%2C%20coral%20and%20green%20accents%2C%20clean%20composition&width=900&height=600&seq=chigua-must-01&orientation=landscape",
    heat: 9120,
    date: "09-08",
    readTime: "7 分钟",
    tags: ["观看指南", "名场面"],
    sections: [
      {
        heading: "先看先导片和第一期",
        body: "先导片通常会把节目规则和嘉宾关系交代清楚，是建立观看框架最快的方式。第一期则集中展示初始人物关系，后续很多互动的伏笔都埋在这里。",
      },
      {
        heading: "中期挑高能环节看",
        body: "群像综艺进入中段后节奏趋于稳定，可以只挑游戏结果揭晓、组队变故与情绪爆点这三类环节观看，既不影响理解，也能压缩大量时间。",
      },
      {
        heading: "收官前务必补花絮",
        body: "很多被正片剪掉的关键互动会放在花絮与加更里，收官前的花絮尤其容易补全人物线索，是判断整季节目的重要补充。",
      },
      {
        heading: "这样看能省多少时间",
        body: "按上述方式，一档十二期的群像综艺大约可以压缩到三分之一时长，同时保住主线剧情与主要名场面，适合时间有限但想跟上讨论的观众。",
      },
    ],
    points: [
      "先导片用来建立规则与人物关系框架",
      "中段只挑情绪爆点与结果揭晓环节",
      "花絮与加更常包含被正片剪掉的关键互动",
    ],
  },
  {
    id: "must-set-timeline",
    title: "追剧时间线：从开拍到定档需要多久",
    summary: "以一部剧为样本，梳理从开机到定档的完整时间节点，帮你看懂物料发布的节奏。",
    categoryId: "setlife",
    categoryName: "剧组路透",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20timeline%20notebook%20with%20amber%20paper%20clips%20on%20cream%20desk%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20coral%20accent%2C%20minimal%20clean%20composition&width=900&height=600&seq=chigua-must-02&orientation=landscape",
    heat: 7480,
    date: "09-07",
    readTime: "6 分钟",
    tags: ["时间线", "定档"],
    sections: [
      {
        heading: "开机到杀青",
        body: "开机通常配合首波物料放出，随后进入相对安静的拍摄期。这一阶段公开信息较少，多以外景路透和零散花絮为主，持续时间视项目规模而定。",
      },
      {
        heading: "杀青到首支预告",
        body: "杀青后进入后期制作，剪辑、配乐与调色都需要时间。首支预告往往在后期基本完成后放出，用来测试市场反馈并确定宣传节奏。",
      },
      {
        heading: "预告到正式定档",
        body: "预告发布后如果反馈积极，平台会加快排播安排，定档信息一般会配合新一轮物料同步公布，形成第二个宣传高峰。",
      },
      {
        heading: "为什么有的项目会拖很久",
        body: "排播需要综合考虑平台档期、同类题材竞争与制作完成度，任何一个环节延后都会影响最终上线时间，因此时间线只适合作为参考。",
      },
    ],
    points: [
      "开机与杀青之间为拍摄期，公开信息相对稀少",
      "杀青后仍需完成剪辑、配乐与调色",
      "定档受平台排播与同期竞争影响，存在浮动",
    ],
  },
  {
    id: "must-concert-first",
    title: "第一次看巡演：现场需要准备什么",
    summary: "从入场时间到应援物料，一份写给首次看巡演观众的实用清单。",
    categoryId: "stage",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Concert%20ticket%20stub%20and%20glow%20stick%20on%20warm%20cream%20surface%20with%20amber%20light%2C%20editorial%20photography%2C%20coral%20and%20gold%20accents%2C%20minimal%20clean%20composition&width=900&height=600&seq=chigua-must-03&orientation=landscape",
    heat: 6890,
    date: "09-06",
    readTime: "5 分钟",
    tags: ["现场", "清单"],
    sections: [
      {
        heading: "提前确认入场规则",
        body: "不同场馆对包袋尺寸、应援物与拍摄设备的要求差别很大，建议出发前查阅场馆公布的入场须知，避免携带无法带入的物品。",
      },
      {
        heading: "时间安排怎么留",
        body: "入场高峰通常集中开场前一小时，如果希望从容找到座位，建议提前一个半小时到达场馆周边，预留安检与寻找座位的缓冲时间。",
      },
      {
        heading: "需要带的几样东西",
        body: "身份证件、充电宝与轻便外套是最常被提到的三样物品。场内温度偏低且手机耗电快，提前准备能明显改善现场体验。",
      },
      {
        heading: "散场如何快速离场",
        body: "散场时人流集中，建议提前想好两条离场路线，并尽量避开正门方向。如果选择等待，也可先在场馆附近停留片刻再出发。",
      },
    ],
    points: [
      "进场前先确认场馆的入场与携带物品规则",
      "提前约一个半小时到场，预留安检与找座时间",
      "证件、充电宝与轻便外套是最实用的三件物品",
    ],
  },
  {
    id: "must-redcarpet-basic",
    title: "红毯造型入门：看懂一套造型的三个角度",
    summary: "剪裁、材质与配色，三个角度帮你在刷图时看出更多信息。",
    categoryId: "redcarpet",
    categoryName: "红毯时尚",
    cover:
      "https://readdy.ai/api/search-image?query=Folded%20fashion%20fabric%20swatches%20in%20coral%20cream%20and%20green%20on%20minimal%20desk%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=900&height=600&seq=chigua-must-04&orientation=landscape",
    heat: 5210,
    date: "09-05",
    readTime: "5 分钟",
    tags: ["造型", "入门"],
    sections: [
      {
        heading: "先看剪裁轮廓",
        body: "剪裁决定一套造型的第一印象。收腰、落肩与直筒三种轮廓传达的气质完全不同，先判断轮廓，再看细节会更容易读懂造型意图。",
      },
      {
        heading: "再看材质与光泽",
        body: "缎面、丝绒与金属质感面料在闪光灯下的表现差异明显。光泽度高的材质更容易成为画面焦点，哑光材质则更适合强调结构。",
      },
      {
        heading: "最后看配色关系",
        body: "配色需要结合红毯底色一起看。暖色系在深色背景前更显眼，冷色系则更容易与浅色背景融为一体，这也是同一套造型在不同场合观感不同的原因。",
      },
    ],
    points: [
      "轮廓是第一印象，收腰与落肩气质差异明显",
      "光泽材质在闪光灯下更容易抢占视觉焦点",
      "配色要结合红毯底色一起判断",
    ],
  },
  {
    id: "must-fandom-etiquette",
    title: "应援礼仪手册：线下活动需要注意的细节",
    summary: "整理线下活动常见的注意事项，让参与体验更顺畅也更体面。",
    categoryId: "fandom",
    categoryName: "粉丝互动",
    cover:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20colorful%20banners%20and%20lanyards%20on%20warm%20cream%20table%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20coral%20gold%20green%20accents%2C%20minimal%20composition&width=900&height=600&seq=chigua-must-05&orientation=landscape",
    heat: 4870,
    date: "09-04",
    readTime: "6 分钟",
    tags: ["应援", "礼仪"],
    sections: [
      {
        heading: "遵守场馆与活动规则",
        body: "不同活动对应援物的尺寸和种类都有明确规定，提前了解并按规范准备，既能顺利入场，也是对其他观众的基本尊重。",
      },
      {
        heading: "注意拍摄边界",
        body: "拍摄时避免长时间举起设备遮挡后排视线，也尽量不要在通道位置停留。良好的观看秩序是所有人体验的基础。",
      },
      {
        heading: "散场带走自己的物料",
        body: "活动结束后主动清理自己产生的垃圾并带走剩余物料，是让应援能够长期被场馆接受的关键一步。",
      },
    ],
    points: [
      "提前核对场馆对应援物尺寸的要求",
      "拍摄时避免遮挡后排与占用通道",
      "散场带走物料与垃圾，维护现场秩序",
    ],
  },
  {
    id: "must-brand-calendar",
    title: "品牌发布日历：本月值得留意的几个节点",
    summary: "按月整理品牌发布的关键节点，方便提前安排关注计划。",
    categoryId: "brand",
    categoryName: "品牌代言",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20monthly%20calendar%20with%20amber%20markers%20on%20cream%20desk%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20coral%20accent%2C%20clean%20minimal%20composition&width=900&height=600&seq=chigua-must-06&orientation=landscape",
    heat: 4020,
    date: "09-02",
    readTime: "4 分钟",
    tags: ["日历", "发布"],
    sections: [
      {
        heading: "月初的时装与美妆节点",
        body: "时装与美妆品牌通常集中在月初发布新一轮物料，配合线下投放同步推进，节奏紧凑且视觉呈现最为突出。",
      },
      {
        heading: "中旬的数码与家电节点",
        body: "数码与家电品类更看重功能演示，物料以使用场景为主，发布周期更长，会分阶段释放产品细节，适合持续跟踪。",
      },
      {
        heading: "月末的快消与促销节点",
        body: "快消品牌往往把发布与促销绑在同一个节点，形成短期集中曝光，这一阶段的物料数量最多但单条热度相对分散。",
      },
    ],
    points: [
      "月初以时装美妆物料为主，视觉呈现突出",
      "中旬数码家电侧重功能演示与长周期传播",
      "月末快消品牌常与促销节点叠加发布",
    ],
  },
];

export const faqs: Faq[] = [
  {
    q: "吃瓜合集导航主要整理哪些内容？",
    a: "我们按主题聚合娱乐话题，覆盖综艺、剧组、音乐现场、红毯时尚、粉丝互动与品牌动态六个方向，每个话题都会整理背景、时间线与看点清单，方便一次性看完。",
  },
  {
    q: "合集里的内容多久更新一次？",
    a: "热门事件类合集会在话题出现后尽快整理，一周盘点固定在每周更新一次，必看清单则根据收藏与阅读情况不定期调整。",
  },
  {
    q: "内容来源是什么？",
    a: "合集均基于公开可见的节目内容、官方物料与公开讨论进行整理与转述，属于主题化的信息汇编，不做未经证实信息的传播，也不涉及任何个人隐私。",
  },
  {
    q: "可以按分类筛选吗？",
    a: "可以。在合集导航页顶部可以切换分类，也可以直接输入关键词搜索，筛选结果会实时更新，无需刷新页面。",
  },
  {
    q: "发现内容有出入怎么办？",
    a: "欢迎通过页面底部的联系邮箱反馈，我们会核对公开信息源后尽快修正或补充说明，并在合集里标注更新时间。",
  },
  {
    q: "站内内容可以转载吗？",
    a: "用于个人分享与讨论没有问题，请保留出处链接。如需用于商业用途，请先通过联系邮箱与我们沟通。",
  },
];

export const quotes: Quote[] = [
  {
    id: "q1",
    name: "小满",
    role: "三年吃瓜用户",
    text: "最喜欢它的一周盘点，周末花十分钟就能把这一周发生的事情补齐，不用再翻十几个平台。",
  },
  {
    id: "q2",
    name: "阿哲",
    role: "追综艺党",
    text: "合集把背景和看点分得很清楚，先看要点清单再决定要不要深看，省了我很多时间。",
  },
  {
    id: "q3",
    name: "Luna",
    role: "造型爱好者",
    text: "红毯那几篇的分类方式很实用，按配色整理之后，刷图时能看出更多设计上的细节。",
  },
];